import { useState } from "react";

import { OutcomeRubricStrategyCard } from "./OutcomeRubricStrategyCard";
import { countDifferentRubricFields } from "./outcome-rubric-comparison";

import { OutcomeImportRubricStrategy } from "api/api-server-outcome-transfer";
import { RubricType } from "components/server-types";
import { t } from "i18n/i18n";
import { Banner } from "mds/components/Banner";

export function OutcomeRubricStrategyOptions({
  canReplaceOrganizationRubric,
  destinationOrganizationName,
  destinationOutcomeCount,
  destinationRubric,
  isImportPending,
  sourceOrganizationName,
  sourceRubric,
  onImportWithRubricStrategy,
}: {
  canReplaceOrganizationRubric: boolean;
  destinationOrganizationName: string;
  destinationOutcomeCount: number;
  destinationRubric: RubricType;
  isImportPending: boolean;
  sourceOrganizationName: string;
  sourceRubric: RubricType;
  onImportWithRubricStrategy: (strategy: OutcomeImportRubricStrategy) => void;
}) {
  const [hasAcknowledgedRubricReplacement, setHasAcknowledgedRubricReplacement] = useState(false);
  const differentRubricFieldCount = countDifferentRubricFields(destinationRubric, sourceRubric);
  const rubricStrategyOptions = [
    {
      comparisonRubric: sourceRubric,
      organizationName: destinationOrganizationName,
      rubric: destinationRubric,
      rubricOrigin: "destination",
    },
    {
      comparisonRubric: destinationRubric,
      organizationName: sourceOrganizationName,
      rubric: sourceRubric,
      rubricOrigin: "source",
    },
  ] as const;

  return (
    <div className="mb-4 space-y-4">
      <h3>{t("outcome_transfer.rubric_handling")}</h3>
      <Banner kind="warning">
        <div>
          <p>{t("outcome_transfer.different_rubric")}</p>
          <p className="text-xs">
            {t("outcome_transfer.difference_summary", { count: differentRubricFieldCount })}
          </p>
        </div>
      </Banner>
      <div className="grid gap-4 sm:grid-cols-2">
        {rubricStrategyOptions.map(
          ({ comparisonRubric, organizationName, rubric, rubricOrigin }) => (
            <OutcomeRubricStrategyCard
              canReplaceOrganizationRubric={canReplaceOrganizationRubric}
              comparisonRubric={comparisonRubric}
              destinationOutcomeCount={destinationOutcomeCount}
              hasAcknowledgedRubricReplacement={hasAcknowledgedRubricReplacement}
              isImportPending={isImportPending}
              key={rubricOrigin}
              organizationName={organizationName}
              rubric={rubric}
              rubricOrigin={rubricOrigin}
              onAcknowledgedRubricReplacementChange={setHasAcknowledgedRubricReplacement}
              onImportWithRubricStrategy={onImportWithRubricStrategy}
            />
          ),
        )}
      </div>
    </div>
  );
}
